module.exports = __webpack_public_path__ + "img/Go.531596bc.jpg";